import { defineStore } from 'pinia'
import axios from 'axios'
import { ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const useCreditContactStore = defineStore('CreditContactStore', {
    state: () => {
        return {
            creditor_name: ref(''),
            fax_number: ref(''),
            address: ref(''),
            address_line: ref(''),
            city: ref(''),
            state: ref(''),
            zipcode: ref(''),
            phone: ref(''),
            type: ref(1),
            route: useRoute(),
            router: useRouter(),
            credit_contact_id: ref(''),
        }
    },
    actions: {
        create() {
            let params = {};
            if (this.route.params && this.route.params.client) {
                params.client = this.route.params.client;
                params.team = this.route.params.team;
            }
            const route = this.router.resolve(
                {
                    name: 'credit-contact-store',
                    params: params
                }
            );
            let $this = this;
            axios.post(
                route.href,
                {
                    creditor_name: $this.creditor_name,
                    fax_number: $this.fax_number,
                    address: $this.address,
                    address_line: $this.address_line,
                    city: $this.city,
                    state: $this.state,
                    zipcode: $this.zipcode,
                    phone: $this.phone,
                }
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    window.location.href = response.data.data.url;
                }, 3000)
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        updateFaxNumber(faxNumber) {
            this.fax_number = faxNumber;
        },
        updatePhoneNumber(PhoneNumber) {
            this.phone = PhoneNumber;
        }
    },
    getters: {
    },
})